import React from "react";
import styles from './horizontal-bars.module.css';

export const HorizontalBars = ({ data }) => {
    const maxWidth = Math.min(280, window.innerWidth - 80);
    const maxDays = Math.max(
        data[0]?.datetimes?.length, // data is sorted by this value, so we choose the first one
        5
    );
    const barWidths = data.map((element) => (element.datetimes.length / maxDays) * maxWidth);

    return (
        <div className={styles.chartContainer}>
            {barWidths.map((width, index) => (
                <div key={index} className={styles.barWrapper}>
                    <div className={styles.timeLabel}>
                        <span style={{fontSize: "1.15rem", marginRight: "6px"}}>{data[index].timeEmoji}</span>
                        {data[index].userFriendlyTimeWindow}
                    </div>
                    <div className={styles.bar} style={{ width: `${width}px` }}>
                        <div className={styles.countLabel}>{data[index].datetimes.length} days</div>
                    </div>
                </div>
            ))}
        </div>
    );
};
